<template>
	<div class="mb-0 pa-2">
		<div class="mb-4">
			<h3 class="pb-2 mt-8">{{ categoria.titulo }}</h3>
			<span v-if="categoria.subtitulo" v-html="categoria.subtitulo" style="color:rgba(0,0,0,0.6)">
			</span>
		</div>
		<Campo v-for="campo in campos" :key="campo.id" :campo="campo"
			@combinacion-changed="$emit('combinacion-changed', $event)"
			@documento-changed="$emit('documento-changed', $event)" @alert-event="$emit('alert-event', $event)" />
	</div>
</template>

<script>
import api from '@Base/services/auditoriaService'
import Campo from './Campo.vue';

export default {
	name: 'Categoria',
	components: {
		Campo
	},
	props: ['categoria', 'campos'],
	data() {
		return {
		}
	}
}
</script>